import React from 'react'
import { Card } from 'react-bootstrap';
import '../home.scss'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
// import faker from 'faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
        x: {
            ticks: {
                color: 'black', // this will change the color of the labels.
                font: {
                    size: 10,
                },
                // this will specify the padding from the label to the axis.
            },
            grid: {
                display: false, // this will hide the grid lines.
            },
            maxRotation: 0, // this will remove the tilt.
            minRotation: 0, // this will remove the tilt.
        },
        y: {
            // ...any configuration for y-axis
            ticks: {
                color: 'black', // this will change the color of the labels.
                font: {
                    size: 10,
                },
                // this will specify the padding from the label to the axis.
            },
            grid: {
                display: false, // this will hide the grid lines.
            }
        }
    },
    plugins: {
        legend: {
            // display: false,
            position: "top"
        },
        title: {
            display: false,
            text: "Chart.js Bar Chart"
        },
        // tooltip: {
        //     enabled: false
        // },
    }
};

const labels = [
    "January",
    "Feb",
    "March",
    "April",
    "May",
    "June",
];
const fakeData = [700, 500, 300, 800, 400, 500,];
const fakeData2 = [400, 200, 600, 500, 300, 700,];

// const fakeData = [0, 0, 0, 0, 0, 0,];
// const fakeData2 = [0, 0, 0, 0, 0, 0,];
export const data = {
    labels,
    datasets: [
        {
            label: "Earnings",
            data: fakeData,
            backgroundColor: "#0AC947"
        },
        {
            label: "Expenses",
            data: fakeData2,
            backgroundColor: "rgba(10, 201, 71, 0.14)"
        }
    ]
};



const Reports = () => {

    return (
        <>
            <Card className='finance-card' style={{ padding: '1rem' }}>
                <p className='finance-para' style={{ fontSize: '14px', fontWeight: 700, color: 'black' }}>Reports</p>

                <div className='d-flex justify-content-center' style={{ width: '100%', height:'90%',  }}>
                    <Bar options={options} data={data} style={{ width: '60%', cursor: 'pointer'}} />
                </div>
            </Card>
        </>
    )
}

export default Reports;